import camelCase from 'lodash/camelCase';

// events
const LOGIN = 'login';
const LOGIN_FAIL = 'login_fail';
const LOGOUT = 'logout';
const STORE_CHANGED = 'store_changed';
const EXPORT_REPORT = 'export_report';
const REPORT_EXPORTED = 'report_exported';
const VIEW_REPORT = 'view_report';
const REPORT_VIEWED = 'report_viewed';
const REPORT_DETAIL_VIEWED = 'report_detail_viewed';
const VIEW_REPORT_DETAIL = 'view_report_detail';
const VIEW_MENU_MAKER = 'view_menu_maker';
const VIEW_MENU_MAKER_DETAIL = 'view_menu_maker_detail';
const MENU_MAKER_FILTERS = 'menu_maker_filters';
const MENU_MAKER = 'menu_maker';
const MENU_MAKER_PUBLISHING = 'menu_maker_publishing';
const VIEW_COPY_MENU = 'view_copy_menu';
const COPY_MENU = 'copy_menu';
const VIEW_STORE = 'view_store';
const ORGANIZATION_SWITCHED = 'organization_switched';
const PAYMENT_CONFIGURATION_STARTED = 'payment_configuration_started';
const PAYMENT_CONFIGURATION_FINISHED = 'payment_configuration_finished';
const PAYMENT_METHOD_SAVED = 'payment_method_saved';
const DETAIL_VIEWED = 'detail_viewed';
const PAYMENT_STARTED = 'payment_started';
const PAYMENT_STEP_VIEWED = 'payment_step_viewed';
const PAYMENT_FINISHED = 'payment_finished';
const INVOICING_SELECTED = 'invoicing_selected';
const INVOICE_RETRY_STARTED = 'invoice_retry_started';
const INVOICE_RETRY_FINISHED = 'invoice_retry_finished';
const INVOICE_DATA_UPDATED = 'invoice_data_updated';
const ROLE_SAVED = 'role_saved';
const REPORT_REDIRECTED = 'report_redirected';
const EVENTS_EXPORTED = 'events_exported';
const EVENTS_DETAIL_CLICKED = 'event_detail_clicked';
const PURCHASE_UPLOADED = 'purchase_uploaded';
const ITEM_MODIFIED = 'item_modified';
const TICKET_DATA_PREVIEW = 'ticket_data_previewed';
const EDITION_COMPLETED = 'edition_completed';
const INVOICE_GENERATED = 'invoice_generated';
const TICKET_CONFIGURED = 'ticket_configured';
const ORDER_SEPARATION = 'order_separation';
const REPORT_FILTER_MODIFIED = 'report_filter_modified';
const REPORT_FILTER_APPLIED = 'report_filter_applied';

// types and sections
const SALES = 'sales';
const DAILY_SETTLEMENT = 'daily_settlement';
const CASH_OUTS = 'cash_outs';
const CASH = 'cash';
const DRAWERS = 'drawers';
const ORDERS = 'orders';
const PAYMENTS = 'payments';
const VOIDS = 'voids';
const DISCOUNTS = 'discounts';
const MENU = 'menu';
const SHIFT = 'shift';
const DAILY = 'daily';
const CATEGORIES = 'categories';
const PRODUCTS = 'products';
const MODIFIERS = 'modifiers';
const SALES_PER_TIME = 'sales_per_time';
const PUBLICATION = 'publication';
const COPY = 'copy';
const SYNC = 'sync';
const SYNC_COPY = 'SYNC_COPY';
const INVENTORY = 'inventory';
const SUBSCRIPTION = 'subscription';
const AVERAGE_TICKET = 'average_ticket';
const BALANCE_SHEET = 'balance_sheet';
const EATER_DATA = 'eater_data';

// type view report
const SUMMARY = 'summary';
const MOVEMENTS = 'movements';
const COMPLETE = 'complete';
const NEW = 'new';
const EDIT = 'edit';
const DELETE = 'delete';
const DUPLICATE = 'duplicate';
const STORE = 'store';
const MULTI_STORE = 'multistore';

// search
const STRING = 'string';

// type provider publish
const UBER = 'uber';
const DIDI = 'didi';
const RAPPI = 'rappi';
const POS = 'pos';
const ONLINE = 'online';

const PARROT = 'PARROT';
const UBER_EATS = 'UBER_EATS';
const DIDI_FOOD = 'DIDI_FOOD';

// status
const SUCCESS = 'success';
const ERROR = 'error';
const START = 'start';
const FINISH = 'finish';
const FAILED = 'failed';
const ISSUED = 'issued';
const REJECTED = 'rejected';

// inventories types
const INVENTORY_PURCHASES = 'inventory_purchases';
const INVENTORY_LOSS = 'inventory_loss';
const INVENTORY_TRANSFER = 'inventory_transfer';
const XML = 'xml';

// eaters data types
const EATER_DETAIL = 'eater_detail';

// cash out types
const TIP = 'tip';
const ALL = 'all';
export const config = {
  '@event': {
    $login: {
      [camelCase([LOGIN])]: LOGIN,
      [camelCase([LOGOUT])]: LOGOUT,
      [camelCase([LOGIN_FAIL])]: LOGIN_FAIL,
    },

    $reports: {
      [camelCase([EXPORT_REPORT])]: EXPORT_REPORT,
      [camelCase([VIEW_REPORT])]: VIEW_REPORT,
      [camelCase([REPORT_VIEWED])]: REPORT_VIEWED,
      [camelCase([REPORT_DETAIL_VIEWED])]: REPORT_DETAIL_VIEWED,
      [camelCase([REPORT_EXPORTED])]: REPORT_EXPORTED,
      [camelCase([VIEW_REPORT_DETAIL])]: VIEW_REPORT_DETAIL,
      [camelCase([REPORT_REDIRECTED])]: REPORT_REDIRECTED,
      [camelCase([REPORT_FILTER_MODIFIED])]: REPORT_FILTER_MODIFIED,
      [camelCase([REPORT_FILTER_APPLIED])]: REPORT_FILTER_APPLIED,
    },

    $store: {
      [camelCase([STORE_CHANGED])]: STORE_CHANGED,
      [camelCase([VIEW_STORE])]: VIEW_STORE,
      [camelCase([ORGANIZATION_SWITCHED])]: ORGANIZATION_SWITCHED,
    },

    $menuMaker: {
      [camelCase([VIEW_MENU_MAKER])]: VIEW_MENU_MAKER,
      [camelCase([VIEW_MENU_MAKER_DETAIL])]: VIEW_MENU_MAKER_DETAIL,
      [camelCase([MENU_MAKER_FILTERS])]: MENU_MAKER_FILTERS,
      [camelCase([MENU_MAKER])]: MENU_MAKER,
      [camelCase([MENU_MAKER_PUBLISHING])]: MENU_MAKER_PUBLISHING,
      [camelCase([VIEW_COPY_MENU])]: VIEW_COPY_MENU,
      [camelCase([COPY_MENU])]: COPY_MENU,
    },

    $subscription: {
      [camelCase([PAYMENT_CONFIGURATION_STARTED])]: PAYMENT_CONFIGURATION_STARTED,
      [camelCase([PAYMENT_CONFIGURATION_FINISHED])]: PAYMENT_CONFIGURATION_FINISHED,
      [camelCase([PAYMENT_METHOD_SAVED])]: PAYMENT_METHOD_SAVED,
      [camelCase([DETAIL_VIEWED])]: DETAIL_VIEWED,
      [camelCase([PAYMENT_STARTED])]: PAYMENT_STARTED,
      [camelCase([PAYMENT_STEP_VIEWED])]: PAYMENT_STEP_VIEWED,
      [camelCase([PAYMENT_FINISHED])]: PAYMENT_FINISHED,
      [camelCase([INVOICING_SELECTED])]: INVOICING_SELECTED,
      [camelCase([INVOICE_RETRY_STARTED])]: INVOICE_RETRY_STARTED,
      [camelCase([INVOICE_RETRY_FINISHED])]: INVOICE_RETRY_FINISHED,
      [camelCase([INVOICE_DATA_UPDATED])]: INVOICE_DATA_UPDATED,
    },

    $workforce: {
      [camelCase([ROLE_SAVED])]: ROLE_SAVED,
    },
    $inventories: {
      [camelCase([EVENTS_EXPORTED])]: EVENTS_EXPORTED,
      [camelCase([EVENTS_DETAIL_CLICKED])]: EVENTS_DETAIL_CLICKED,
      [camelCase([PURCHASE_UPLOADED])]: PURCHASE_UPLOADED,
      [camelCase([ITEM_MODIFIED])]: ITEM_MODIFIED,
    },
    $invoicing: {
      [camelCase([TICKET_DATA_PREVIEW])]: TICKET_DATA_PREVIEW,
      [camelCase([EDITION_COMPLETED])]: EDITION_COMPLETED,
      [camelCase([INVOICE_GENERATED])]: INVOICE_GENERATED,
    },
    $settings: {
      [camelCase([TICKET_CONFIGURED])]: TICKET_CONFIGURED,
      [camelCase([ORDER_SEPARATION])]: ORDER_SEPARATION,
    },
  },

  '@@type': {
    [camelCase([DAILY_SETTLEMENT])]: DAILY_SETTLEMENT,
    [camelCase([CASH_OUTS])]: CASH_OUTS,
    [camelCase([SUMMARY])]: SUMMARY,
    [camelCase([COMPLETE])]: COMPLETE,
    [camelCase([SALES])]: SALES,
    [camelCase([DRAWERS])]: DRAWERS,
    [camelCase([ORDERS])]: ORDERS,
    [camelCase([PAYMENTS])]: PAYMENTS,
    [camelCase([VOIDS])]: VOIDS,
    [camelCase([DISCOUNTS])]: DISCOUNTS,
    [camelCase([NEW])]: NEW,
    [camelCase([EDIT])]: EDIT,
    [camelCase([DELETE])]: DELETE,
    [camelCase([DUPLICATE])]: DUPLICATE,
    [camelCase([UBER_EATS])]: UBER,
    [camelCase([DIDI_FOOD])]: DIDI,
    [camelCase([RAPPI])]: RAPPI,
    [camelCase([PARROT])]: POS,
    [camelCase([ONLINE])]: ONLINE,
    [camelCase([COPY_MENU])]: COPY,
    [camelCase([SYNC_COPY])]: SYNC,
    [camelCase([STORE])]: STORE,
    [camelCase([MULTI_STORE])]: MULTI_STORE,
    [camelCase([SHIFT])]: SHIFT,
    [camelCase([DAILY])]: DAILY,
    [camelCase([TIP])]: TIP,
    [camelCase([ALL])]: ALL,
    [camelCase([CASH_OUTS])]: CASH_OUTS,
    [camelCase([MOVEMENTS])]: MOVEMENTS,
  },

  '@@event_type': {
    [camelCase([SUMMARY])]: SUMMARY,
    [camelCase([INVENTORY_PURCHASES])]: INVENTORY_PURCHASES,
    [camelCase([INVENTORY_LOSS])]: INVENTORY_LOSS,
    [camelCase([INVENTORY_TRANSFER])]: INVENTORY_TRANSFER,
    [camelCase([XML])]: XML,
    [camelCase([EATER_DETAIL])]: EATER_DETAIL,
  },

  '@@section': {
    [camelCase([CASH])]: CASH,
    [camelCase([CASH_OUTS])]: CASH_OUTS,
    [camelCase([DAILY_SETTLEMENT])]: DAILY_SETTLEMENT,
    [camelCase([SALES])]: SALES,
    [camelCase([DRAWERS])]: DRAWERS,
    [camelCase([ORDERS])]: ORDERS,
    [camelCase([PAYMENTS])]: PAYMENTS,
    [camelCase([VOIDS])]: VOIDS,
    [camelCase([DISCOUNTS])]: DISCOUNTS,
    [camelCase([SUMMARY])]: SUMMARY,
    [camelCase([MENU])]: MENU,
    [camelCase([CATEGORIES])]: CATEGORIES,
    [camelCase([PRODUCTS])]: PRODUCTS,
    [camelCase([MODIFIERS])]: MODIFIERS,
    [camelCase([SALES_PER_TIME])]: SALES_PER_TIME,
    [camelCase([PUBLICATION])]: PUBLICATION,
    [camelCase([SUBSCRIPTION])]: SUBSCRIPTION,
    [camelCase([INVENTORY])]: INVENTORY,
    [camelCase([AVERAGE_TICKET])]: AVERAGE_TICKET,
    [camelCase([BALANCE_SHEET])]: BALANCE_SHEET,
    [camelCase([EATER_DATA])]: EATER_DATA,
  },

  '@@item': {
    [camelCase([MENU])]: MENU,
    [camelCase([CATEGORIES])]: CATEGORIES,
    [camelCase([PRODUCTS])]: PRODUCTS,
    [camelCase([MODIFIERS])]: MODIFIERS,
  },

  '@@search': {
    [camelCase([STRING])]: STRING,
  },

  '@@status': {
    [camelCase([SUCCESS])]: SUCCESS,
    [camelCase([ERROR])]: ERROR,
    [camelCase([START])]: START,
    [camelCase([FINISH])]: FINISH,
    [camelCase([FAILED])]: FAILED,
    [camelCase([ISSUED])]: ISSUED,
    [camelCase([REJECTED])]: REJECTED,
  },
};
